import { categoryCodeTab } from '@/layout/state/state';
import requestTabTemplate from './requestTabTemplate';

export default {
  ...requestTabTemplate(['requests', 'request'], ({ requests }) => requests.create),
  componentState: ({ args, url }) => categoryCodeTab(url, args[4]),
};
